<template>
<div class="content-class">
	<v-tabs color="black" dark slider-color="primary">
		<v-tab ripple>Groupes</v-tab>
	</v-tabs>
	<sub-bot-list :url="'subBots?filter=bot._id:$eq:'+$route.params.botId">
	</sub-bot-list>
</div>
</template>

<script>
import SubBotList from '../../components/subBots/subBot.list'

export default {
	components: { SubBotList }
}
</script>

<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/subBots/subBots.list.vue